<div class="custom-toolbar">
  <button
    mat-icon-button
    mat-medium-icon-button
    type="button"
    class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
    [class.NgxEditor--Disabled]="isOutdentDisabled"
    (mousedown)="handleOutdent($event)"
    [disabled]="isOutdentDisabled"
    [title]="'TEMPLATES.EDITOR.OUTDENT_LIST' | translate"
  >
    <mat-icon>format_indent_decrease</mat-icon>
  </button>
  <button
    mat-icon-button
    mat-medium-icon-button
    type="button"
    class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
    [class.NgxEditor--Disabled]="isIndentDisabled"
    (mousedown)="handleIndent($event)"
    [disabled]="isIndentDisabled"
    [title]="'TEMPLATES.EDITOR.INDENT_LIST' | translate"
  >
    <mat-icon>format_indent_increase</mat-icon>
  </button>
  @if (allowPlaceholders) {
    <div class="NgxEditor__Seperator"></div>
    <button
      mat-button
      type="button"
      class="NgxEditor__MenuItem NgxEditor__MenuItem--Text placeholder-button"
      [class.NgxEditor__MenuItem--Active]="isActive"
      [class.NgxEditor--Disabled]="isDisabled"
      (mousedown)="handleClick($event)"
      [disabled]="isDisabled"
      [title]="'TEMPLATES.EDITOR.INSERT_PLACEHOLDER' | translate"
    >
      <mat-icon>data_object</mat-icon>
      {{ 'TEMPLATES.EDITOR.INSERT_PLACEHOLDER' | translate }}
    </button>
  }
  <div class="NgxEditor__Seperator"></div>
  <button
    mat-icon-button
    mat-medium-icon-button
    type="button"
    class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
    [class.NgxEditor--Disabled]="isUndoDisabled"
    (mousedown)="handleUndo($event)"
    [disabled]="isUndoDisabled"
    [title]="'TEMPLATES.EDITOR.UNDO' | translate"
  >
    <mat-icon>undo</mat-icon>
  </button>
  <button
    mat-icon-button
    mat-medium-icon-button
    type="button"
    class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
    [class.NgxEditor--Disabled]="isRedoDisabled"
    (mousedown)="handleRedo($event)"
    [disabled]="isRedoDisabled"
    [title]="'TEMPLATES.EDITOR.REDO' | translate"
  >
    <mat-icon>redo</mat-icon>
  </button>
</div>
